import React, { Component } from "react";
import { checkRolePermissions } from "../../../utils/Helper";
import { moduleName, URL } from "../../../utils/Constants";
import CustomModal from "../../../components/WebsiteComponents/CustomModal";
import AddDocumentTypes from "./AddDocumentTypes";
import { axiosGet, axiosPost } from "../../../utils/AxiosApi";
import {
  displayConfirmDeleteAlert,
  displayErrorAlert,
  DISPLAYMESSAGE,
} from "../../../utils/DisplayMessage";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import CustomFullSpinner from "../../../components/WebsiteComponents/CustomFullSpinner";
import Pagination from "react-js-pagination";

class Documents extends Component {
  state = {
    createModal: false,
    deletePermission: false,
    documentTypes: [],
    edit: false,
    selectedData: {},
    spinner: false,
    updatePermission: false,
    fullSpinner: false,
    current_page: 1,
    totalItemsCount: 0,
    paginated_value: 10,
  };

  componentDidMount() {
    this.permissions();
  }

  deleteData = (params) => {
    this.setState({ spinner: true }, () => {
      axiosGet(
        URL.deleteDocumentTypes + "/" + params.id,
        (response) => {
          if (response.status === 200) {
            swal("Success", DISPLAYMESSAGE.deleteSuccess, "success");
            this.setState({ spinner: false });
            this.getDocumentTypes();
          }
        },
        (err) => {
          this.setState({ spinner: false });

          displayErrorAlert(err);
        }
      );
    });
  };

  getDocumentTypes = (pageNumber, paginated_value) => {
    let page = pageNumber || this.state.current_page
    let paginatedValue = paginated_value || this.state.paginated_value
    let param = {
      page: page,
      paginated_value: paginatedValue,
    }
    this.setState({ fullSpinner: true }, function () {
      axiosPost(
        URL.documentTypes + "/get-legal-documents", param,
        (response) => {
          this.setState({ fullSpinner: false });
          if (response.status === 200) {
            this.setState({ current_page: page,paginated_value:paginatedValue, documentTypes: response.data.data.items, totalItemsCount: response.data.data.totalData });
          }
        },
        (err) => {
          this.setState({ fullSpinner: false });
          displayErrorAlert(err);
        }
      );
    });
  };

  handleCreateModal = () => {
    this.setState({
      createModal: !this.state.createModal,
      edit: false,
    });
  };

  handleDelete = (id) => {
    let params = { id: id };
    displayConfirmDeleteAlert(params, this.deleteData);
  };

  handleEdit = (data) => {
    this.setState({
      selectedData: data,
      edit: true,
      createModal: !this.state.createModal,
    });
  };

  permissions = () => {
    this.setState(
      {
        updatePermission: checkRolePermissions("update", moduleName.documents),
        deletePermission: checkRolePermissions("delete", moduleName.documents),
      },
      function () {
        this.getDocumentTypes();
      }
    );
  };

  handlePaginatedValueChange = (value) => {
    let valuePage = parseInt(value);
    this.setState({ paginated_value: valuePage }, () => {
      this.getDocumentTypes(1, valuePage);
    });
  };

  render() {
    const { current_page, paginated_value, totalItemsCount } = this.state;

    return (
      <>
        {this.state.spinner ? <CustomFullSpinner text="Processing...." /> : ""}

        <div className="dashboardHeader">
          <strong>DOCUMENTS</strong>
        </div>
        <div className="container h-100">
          <div className="row mt-2">
            <div className="col">
              {checkRolePermissions("create", moduleName.documents) ? (
                <button
                  className="btn btn-success"
                  onClick={this.handleCreateModal}
                >
                  Add Document Types
                </button>
              ) : null}
            </div>
          </div>
          <div className="row mt-2 h-100">
            <div className="col d-flex align-items-center justify-content-between flex-column">
              <div className="table-responsive w-100">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th className="text-center">S.N.</th>
                      <th>Document Type</th>
                      {this.state.deletePermission ||
                        this.state.updatePermission ? (
                        <th>Actions</th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.documentTypes?.length > 0 ? (
                      this.state.documentTypes?.map((type, idx) => {
                        return (
                          <tr key={idx}>
                            <td className="text-center">{idx + 1}</td>
                            <td>{type.document_type}</td>
                            {this.state.deletePermission ||
                              this.state.updatePermission ? (
                              <td>
                                {this.state.updatePermission ? (
                                  <button
                                    className="btn btn-primary me-2"
                                    onClick={() => this.handleEdit(type)}
                                  >
                                    <i class="fa-solid fa-pen-to-square"></i>
                                  </button>
                                ) : null}
                                {this.state.deletePermission ? (
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => this.handleDelete(type.id)}
                                  >
                                    <i class="fa-solid fa-trash"></i>
                                  </button>
                                ) : null}
                              </td>
                            ) : null}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          className="text-center p-3"
                          colSpan={
                            this.state.updatePermission ||
                              this.state.deletePermission
                              ? 3
                              : 2
                          }
                        >
                          {this.state.spinner ? (
                            <>
                              <Spinner></Spinner>
                              <br />
                              Loading Data...
                            </>
                          ) : (
                            "No Document Types added yet"
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {this.state.totalItemsCount <= 0 ? (
                <></>
              ) : (
                <div className="paginationContainer">
                  <Pagination
                    activePage={current_page}
                    itemsCountPerPage={paginated_value}
                    totalItemsCount={totalItemsCount}
                    onChange={(pageNumber) => this.getDocumentTypes(pageNumber, paginated_value)}
                    itemClass="page-item"
                    linkClass="page-link"
                    firstPageText="First"
                    lastPageText="Last"
                  />
                  <div className="paginatoion_paginated_value ml-3">
                    <select
                      className="form-control"
                      value={this.state.paginated_value}
                      onChange={(e) => this.handlePaginatedValueChange(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={40}>40</option>
                      <option value={50}>50</option>
                    </select>
                  </ div>
                </div>
              )}
            </div>
          </div>
        </div>
        <CustomModal
          modal={this.state.createModal}
          modalBody={
            <AddDocumentTypes
              edit={this.state.edit}
              getDocumentTypes={this.getDocumentTypes}
              handleCreateModal={this.handleCreateModal}
              selectedData={this.state.selectedData}
            />
          }
          modalHeader={
            this.state.edit ? "Update Document Type" : "Add Document Types"
          }
          toggleModal={this.handleCreateModal}
        ></CustomModal>
      </>
    );
  }
}

export default Documents;
